// pages/game/gameRoles.js
export function getFallbackRoleFromVariant(variant) {
  const labels = {
    1: "Coordinateur·rice",
    2: "Analyste données",
    3: "Tech sécurité",
    4: "Observateur·rice",
    5: "Support terrain",
    6: "Archiviste"
  };
  return labels[variant] || `Agent J${variant}`;
}

export function getRoleLabel(player) {
  return player.avatarLabel || getFallbackRoleFromVariant(player.pageVariant);
}